import { createAction } from 'redux-actions';
import { reduxKey } from '../../constants';
const actionPrefix = `${reduxKey}.LAYOUT`;
export const fetchLayoutSuccess = createAction(`${actionPrefix}.FETCH.SUCCESS`, (payload)=>payload);
export const moveModule = createAction(`${actionPrefix}.MOVE_MODULE`, (payload)=>payload);
export const removeModule = createAction(`${actionPrefix}.REMOVE_MODULE`, (payload)=>payload);
export const removeModuleSuccess = createAction(`${actionPrefix}.REMOVE_MODULE_SUCCESS`, (payload)=>payload);
export const updateModuleOrderSuccess = createAction(`${actionPrefix}.UPDATE_MODULE_ORDER.SUCCESS`, (payload)=>payload);
export const addModule = createAction(`${actionPrefix}.ADD_MODULE`, (payload)=>payload);
export const addModuleSuccess = createAction(`${actionPrefix}.ADD_MODULE_SUCCESS`, (payload)=>payload);
export const addModuleFail = createAction(`${actionPrefix}.ADD_MODULE_FAIL`, (payload)=>payload);
export const updateLayoutVersion = createAction(`${actionPrefix}.UPDATE_VERSION`, (payload)=>payload);
